import Strings from '../../../Strings';

const MAX_VIDEO_SIZE = 250 * 1024 * 1024;
const validTypes = { mp4: 'video/mp4', webm: 'video/webm' };

export const selectorKey = selector => selector.selector_kind === 'model'
  ? `model:${selector.device_model_id}`
  : `type:${selector.device_type}`;

export const selectorLabel = selector => selector.selector_kind === 'model'
  ? Strings.formatString(
    Strings.deviceInstructionModelLabel,
    selector.manufacturer || '',
    selector.model || '',
    selector.device_type,
  )
  : Strings.formatString(Strings.deviceInstructionTypeLabel, selector.device_type);

export const validateVideoFile = file => {
  if (!file) return Strings.deviceInstructionChooseFileFirst;
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (validTypes[extension] !== file.type) return Strings.deviceInstructionInvalidFile;
  if (!file.size || file.size > MAX_VIDEO_SIZE) return Strings.deviceInstructionFileTooLarge;
  return '';
};
